import(/* webpackMode: "eager", webpackExports: ["default"] */ "/hisea-ssr/src/components/MedicalProfessionalDiscounts/medicalProfessionalDiscounts.js");
